import { render } from "./SimpleProjectListWidget.vue?vue&type=template&id=c90b2910&ts=true"
import script from "./SimpleProjectListWidget.ts?vue&type=script&lang=ts&external"
export * from "./SimpleProjectListWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__